let language = {
    RETURN_REQUEST_TITLE: "退货申请",
    RETURN_REQUEST_ORDER: "订单号",
    RETURN_REQUEST_RETURN: "退货项目",
    RETURN_REQUEST_QUANTITY: "数量",
    RETURN_REQUEST_QTY: "退货数量",
    RETURN_REQUEST_QTY_TIPS: "请输入有效的数量",
    RETURN_REQUEST_REASON: "原因",
    RETURN_REQUEST_DESCRIPTION: "描述",
    RETURN_REQUEST_UPLOAD: "上传照片",
    RETURN_REQUEST_UPLOAD_TIPS: "您可以上传5张图片，每张图片不得超过50MB。（jpg, jpeg, png, gif, bmp, svg, pdf）",
    RETURN_REQUEST_SUBMITTED: "上传失败的图片将不会被提交。",
    RETURN_REQUEST_UPLOAD_FAIL: "上传失败",
    RETURN_REQUEST_CANCEL: "取消",
    RETURN_REQUEST_COMFIRM: "确认",
};

export { language };
